var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9717 3.4179C19.4822 2.92819 18.901 2.53972 18.2614 2.27468C17.6217 2.00965 16.9361 1.87323 16.2438 1.87323C15.5514 1.87323 14.8658 2.00965 14.2261 2.27468C13.5865 2.53972 13.0053 2.92819 12.5158 3.4179L11.5 4.43373L10.4842 3.4179C9.49547 2.42919 8.1545 1.87374 6.75626 1.87374C5.35802 1.87374 4.01705 2.42919 3.02835 3.4179C2.03964 4.4066 1.48419 5.74757 1.48419 7.14581C1.48419 8.54405 2.03964 9.88502 3.02835 10.8737L4.04418 11.8896L11.5 19.3454L18.9558 11.8896L19.9717 10.8737C20.4614 10.3843 20.8498 9.80309 21.1149 9.16345C21.3799 8.5238 21.5163 7.8382 21.5163 7.14581C21.5163 6.45343 21.3799 5.76783 21.1149 5.12818C20.8498 4.48853 20.4614 3.90737 19.9717 3.4179V3.4179Z",
    stroke: "#ea9e8d",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1cc4e020eb60cf8b52d3bc69daacb1ec.svg";
export { ForwardRef as ReactComponent };